import { TypedPath } from '../../../types/routes';

const platformBasePath = '/platform';

export const PlatformNavigation = {
  basePath: platformBasePath,

  partyList: {
    pathPattern: () => {
      return `${platformBasePath}/parties`;
    },
    pathFromParams: _params => {
      return `${platformBasePath}/parties`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,
  partyDetails: {
    pathPattern: () => {
      return `${platformBasePath}/parties/:partyId`;
    },
    pathFromParams: params => {
      return `${platformBasePath}/parties/${params.partyId}`;
    },
    paramsFromPath: (match: any) => {
      return { partyId: match.params.partyId };
    }
  } as TypedPath<{ partyId: string }>,

  jobList: {
    pathPattern: () => {
      return `${platformBasePath}/jobs`;
    },
    pathFromParams: _params => {
      return `${platformBasePath}/jobs`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,
  jobDetails: {
    pathPattern: () => {
      return `${platformBasePath}/jobs/:jobId`;
    },
    pathFromParams: params => {
      return `${platformBasePath}/jobs/${params.jobId}`;
    },
    paramsFromPath: (match: any) => {
      return { jobId: match.params.jobId };
    }
  } as TypedPath<{ jobId: string }>,

  platformProducerWithPlatformMerchantOrdersList: {
    pathPattern: () => {
      return `${platformBasePath}/platform-producer-with-platform-orders`;
    },
    pathFromParams: _params => {
      return `${platformBasePath}/platform-producer-with-platform-orders`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,

  platformProducerWithPlatformMerchantOrderDetails: {
    pathPattern: () => {
      return `${platformBasePath}/platform-producer-with-platform-orders/:platformProducerOrderId,:platformMerchantOrderId`;
    },
    pathFromParams: params => {
      return `${platformBasePath}/platform-producer-with-platform-orders/${params.platformProducerOrderId},${params.platformMerchantOrderId}`;
    },
    paramsFromPath: (match: any) => {
      return {
        platformProducerOrderId: match.params.platformProducerOrderId,
        platformMerchantOrderId: match.params.platformMerchantOrderId
      };
    }
  } as TypedPath<{ platformProducerOrderId: string; platformMerchantOrderId: string }>,

  platformMerchantContracts: {
    pathPattern: () => {
      return `${platformBasePath}/platform-merchant-contracts`;
    },
    pathFromParams: _params => {
      return `${platformBasePath}/platform-merchant-contracts`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,
  platformMerchantContractDetails: {
    pathPattern: () => {
      return `${platformBasePath}/platform-merchant-contracts/:merchantContractId`;
    },
    pathFromParams: params => {
      return `${platformBasePath}/platform-merchant-contracts/${params.merchantContractId}`;
    },
    paramsFromPath: (match: any) => {
      return { merchantContractId: match.params.merchantContractId };
    }
  } as TypedPath<{ merchantContractId: string }>,
  platformProducerContracts: {
    pathPattern: () => {
      return `${platformBasePath}/platform-producer-contracts`;
    },
    pathFromParams: _params => {
      return `${platformBasePath}/platform-producer-contracts`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,
  platformSaleCatalogs: {
    pathPattern: () => {
      return `${platformBasePath}/platform-sale-catalogs`;
    },
    pathFromParams: _params => {
      return `${platformBasePath}/platform-sale-catalogs`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,

  platformSaleCatalogDetails: {
    pathPattern: () => {
      return `${platformBasePath}/platform-sale-catalogs/:platformSaleCatalogId`;
    },
    pathFromParams: params => {
      return `${platformBasePath}/platform-sale-catalogs/${params.platformSaleCatalogId}`;
    },
    paramsFromPath: (match: any) => {
      return { platformSaleCatalogId: match.params.platformSaleCatalogId };
    }
  } as TypedPath<{ platformSaleCatalogId: string }>,

  accessoryList: {
    pathPattern: () => {
      return `${platformBasePath}/accessories`;
    },
    pathFromParams: _params => {
      return `${platformBasePath}/accessories`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,
  accessoryDetails: {
    pathPattern: () => {
      return `${platformBasePath}/accessories/:accessoryId`;
    },
    pathFromParams: params => {
      return `${platformBasePath}/accessories/${params.accessoryId}`;
    },
    paramsFromPath: (match: any) => {
      return { accessoryId: match.params.accessoryId };
    }
  } as TypedPath<{ accessoryId: string }>,
  accessoryModelDetails: {
    pathPattern: () => {
      return `${platformBasePath}/accessories/:accessoryId/accessory-models/:accessoryModelId`;
    },
    pathFromParams: params => {
      return `${platformBasePath}/accessories/${params.accessoryId}/accessory-models/${params.accessoryModelId}`;
    },
    paramsFromPath: (match: any) => {
      return { accessoryId: match.params.accessoryId, accessoryModelId: match.params.accessoryModelId };
    }
  } as TypedPath<{ accessoryId: string; accessoryModelId: string }>,
  pieceList: {
    pathPattern: () => {
      return `${platformBasePath}/pieces`;
    },
    pathFromParams: _params => {
      return `${platformBasePath}/pieces`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,
  pieceDetails: {
    pathPattern: () => {
      return `${platformBasePath}/pieces/:pieceId`;
    },
    pathFromParams: params => {
      return `${platformBasePath}/pieces/${params.pieceId}`;
    },
    paramsFromPath: (match: any) => {
      return { pieceId: match.params.pieceId };
    }
  } as TypedPath<{ pieceId: string }>,
  pieceModelDetails: {
    pathPattern: () => {
      return `${platformBasePath}/pieces/:pieceId/piece-models/:pieceModelId`;
    },
    pathFromParams: params => {
      return `${platformBasePath}/pieces/${params.pieceId}/piece-models/${params.pieceModelId}`;
    },
    paramsFromPath: (match: any) => {
      return { pieceId: match.params.pieceId, pieceModelId: match.params.pieceModelId };
    }
  } as TypedPath<{ pieceId: string; pieceModelId: string }>,
  fontList: {
    pathPattern: () => {
      return `${platformBasePath}/fonts`;
    },
    pathFromParams: _params => {
      return `${platformBasePath}/fonts`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,
  fontDetails: {
    pathPattern: () => {
      return `${platformBasePath}/fonts/:fontId`;
    },
    pathFromParams: params => {
      return `${platformBasePath}/fonts/${params.fontId}`;
    },
    paramsFromPath: (match: any) => {
      return { fontId: match.params.fontId };
    }
  } as TypedPath<{ fontId: string }>,
  symbolCollectionList: {
    pathPattern: () => {
      return `${platformBasePath}/symbols`;
    },
    pathFromParams: _params => {
      return `${platformBasePath}/symbols`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,
  symbolCollectionDetails: {
    pathPattern: () => {
      return `${platformBasePath}/symbols/:symbolCollectionId`;
    },
    pathFromParams: params => {
      return `${platformBasePath}/symbols/${params.symbolCollectionId}`;
    },
    paramsFromPath: (match: any) => {
      return { symbolCollectionId: match.params.symbolCollectionId };
    }
  } as TypedPath<{ symbolCollectionId: string }>,
  support: {
    pathPattern: () => {
      return `${platformBasePath}/support`;
    },
    pathFromParams: _params => {
      return `${platformBasePath}/support`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>
};
